import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || "http://localhost:8000"}/api`;
const TOKEN_KEY = "sv_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminApi = {
  login: (email, password) => axios.post(`${API}/auth/login`, { email, password }),
  me: () => axios.get(`${API}/auth/me`, authHeader()),
  quotes: () => axios.get(`${API}/admin/quotes`, authHeader()),
  stats: () => axios.get(`${API}/admin/stats`, authHeader()),
  updateStatus: (id, status) => axios.patch(`${API}/admin/quotes/${id}`, { status }, authHeader()),
  remove: (id) => axios.delete(`${API}/admin/quotes/${id}`, authHeader()),
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
